// Actions only describe what happened,
// but don't describe how the application's state changes.

/*  name each action (constant) as <NOUN>_<VERB> with the present tense: TODO_ADD
action creator name: <verb><Noun>: addTodo
selector name: get<Noun> */

export const setDesignsCount = count => ( {
	type: 'DESIGNS_COUNT_SET',
	count,
} );

export const setDesignLibrary = designs => ( {
	type: 'DESIGN_LIBRARY_SET',
	designs,
} );

export const addImportedSets = set => ( {
	type: 'IMPORTED_SETS_ADD',
	set,
} );

export const emptyImportedSets = () => ( {
	type: 'IMPORTED_SETS_EMPTY',
} );




// WEBPACK FOOTER //
// ./src/actions/designs-actions.js